module.exports = require('../../../gg/js/includes/tracking.js');
